export enum PartialRefundValueType {
  Percentage = 'percentage',
  Amount = 'amount',
};
